export default {
  isEnabled: true,
  isDebugEnabled: false,
  userIdentifierField: 'email'
}
